var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isBusy,
          expression: "isBusy",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Brand", prop: "brand_id", required: "" } },
            [
              _c(
                "el-select",
                {
                  model: {
                    value: _vm.form.brand_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "brand_id", $$v)
                    },
                    expression: "form.brand_id",
                  },
                },
                _vm._l(_vm.brandOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Name", prop: "name", required: "" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: { prop: "expiry_period" },
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            effect: "light",
                            content:
                              "Period of time in days after which the contact list will be deleted from the system",
                            placement: "top-start",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v("Expiry Period "),
                            _c("i", { staticClass: "far fa-question-circle" }),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("el-input", {
                attrs: { clearable: "" },
                model: {
                  value: _vm.form.expiry_period,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "expiry_period", $$v)
                  },
                  expression: "form.expiry_period",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Import Contacts", prop: "contacts_file" } },
            [
              _vm.isFileSelected
                ? _c("div", [
                    _c("em", [_vm._v(_vm._s(this.filename))]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "btn btn-link btn-link-red px-1",
                        on: { click: _vm.clearFile },
                      },
                      [_c("i", { staticClass: "fas fa-times-circle" })]
                    ),
                  ])
                : _c("file-input", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ clickHandler }) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "btn btn-link btn-link-purple px-0",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return clickHandler.apply(null, arguments)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fas fa-folder-open" })]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.form.contacts_file,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "contacts_file", $$v)
                      },
                      expression: "form.contacts_file",
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-purple px-4", on: { click: _vm.store } },
        [_vm._v("Store")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }